import React, {  } from "react";
import { Route, Redirect, } from "react-router-dom";

export default function ProtectedRoute({ component: Component, token, auth, ...rest }){
    token = token ? true : false;
    const authorized = !(token ^ auth);
    return (
        <Route {...rest} render={(props) =>  authorized ? ( <Component /> ) : ( <Redirect to={auth ? "/iniciar-sesion" : "/"} /> ) }
    />
  );
}